export { css, keyframes, Global, ClassNames } from '@emotion/react'; // ensure the same version of emotion

export { Core } from './Core';
export { buildDataAttributes } from './buildDataAttributes';
export { useLinkComponent } from './linkComponent';

export type { CSSObject } from '@emotion/react';

export type { DataAttributeMap } from './buildDataAttributes';
export type { LinkComponentProps } from './linkComponent';

export type ResponsiveProp<T> = T | readonly (T | null)[];
